// Source of truth: InputGUI.py :: temperament_options, expansion_drive_options
// Chaos levels shared across all entity tabs
export const CHAOS_LEVELS = ['High', 'Medium', 'Low'];
export const CULTURE_CHAOS_LEVELS = CHAOS_LEVELS;

export const CULTURE_TEMPERAMENTS = [
  '1 - Serene Pacifists – avoid conflict entirely, even when provoked',
  '2 - Gentle Harmonizers – prefer diplomacy, compromise, and peacekeeping',
  '3 - Warm Hosts – friendly to outsiders, trusting unless betrayed',
  '4 - Cautious Neutrals – reserved and watchful, slow to anger',
  '5 - Proud Traditionalists – easily offended, defend honor and customs',
  '6 - Hardline Defenders – protective, respond forcefully to threats',
  '7 - Suspicious Isolationists – assume outsiders bring danger or corruption',
  '8 - Militant Rivalry – competitive culture, quick to challenge and confront',
  '9 - Ruthless Dominators – intimidation and violence are normal tools',
  '10 - Blood-Forged Raiders – thrive on conquest, raids, and constant war',
];

export const CULTURE_EXPANSION_DRIVES = [
  '1 - Rooted Homeland Keepers – rarely travel far, protect what they already hold',
  '2 - Local Settlers – expand only when resources force slow outward growth',
  '3 - Border Gardeners – build small outposts and farms just beyond their edges',
  '4 - Trade Route Builders – expand through commerce, roads, and safe corridors',
  '5 - Opportunity Seekers – push outward when profit, land, or power is available',
  '6 - Frontier Claimants – steadily establish new towns and territorial claims',
  '7 - Imperial Organizers – expand deliberately with administration, law, and taxation',
  '8 - Colonial Conquerors – seize regions, replace leadership, reshape societies',
  '9 - Crusading Expansionists – spread a "higher purpose" through force and zeal',
  '10 - World-Takers – relentless domination, absorbing lands until stopped',
];
